import { render, staticRenderFns } from "./TaskTypesPage.vue?vue&type=template&id=7395ba70"
import script from "./TaskTypesPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./TaskTypesPage.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7395ba70')) {
      api.createRecord('7395ba70', component.options)
    } else {
      api.reload('7395ba70', component.options)
    }
    module.hot.accept("./TaskTypesPage.vue?vue&type=template&id=7395ba70", function () {
      api.rerender('7395ba70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Pages/TaskManagement/Components/TaskTypesPage.vue"
export default component.exports